<template>
  <div style="display: inline-block">
    <v-btn
      color="grey lighten"
      outline
      v-if="selectedBot.pagetype != 'enterprise' && $store.getters.getPackage != 'premium'"
    >
      <em class="fas fa-exchange-alt mr-1" />
      {{ $t('Transfer') }}
      <v-premium-lock :inline="true" class="ml-2"></v-premium-lock>
    </v-btn>
    <v-btn color="primary" @click="openModal" outline v-else>
      <em class="fas fa-exchange-alt mr-1" />
      {{ $t('Transfer') }}
    </v-btn>
    <v-dialog v-model="showTransfer" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <v-layout wrap row class="mb-0">
            <v-flex xs12 sm5 class="text-xs-center">
              <v-menu offset-y open-on-hover offset-overflow max-height="200">
                <template v-slot:activator="{ on }">
                  <v-btn outline round color="primary" v-on="on">
                    <template v-if="currentPage">
                      <div
                        class="text-truncate"
                        style="
                          display: inline-block;
                          word-break: break-all;
                          max-width: 150px;
                          vertical-align: middle;
                        "
                      >
                        {{ currentPage.name }}
                      </div>
                    </template>
                    <template v-else>{{ $t('Select page') }}</template>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-tile
                    v-for="(item, index) in optionBotlist"
                    :key="index"
                    @click="selectBot(item)"
                  >
                    <v-list-tile-title class="primary-color">{{ item.name }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-flex>

            <v-flex xs12 sm2 class="text-xs-center">
              <em class="fas fa-arrow-right hidden-xs-only mt-3" />
              <em class="fas fa-arrow-down hidden-sm-and-up mt-2" />
            </v-flex>

            <v-flex xs12 sm5 class="text-xs-center pt-3">{{ selectedBot.pagename }}</v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px" class="pa-0">
          <div class="mt-2 mb-2" v-if="loading">
            <scale-loader :color="$vuetify.theme.primary" height="35px" width="7px"></scale-loader>
          </div>
          <div class="text-xs-center mt-4 mb-4" v-else-if="comparelist.length == 0">
            {{ $t('Choose page to transfer') }}
          </div>
          <div class="pb-2" v-else>
            <v-layout style="background: #eee">
              <v-flex>
                <v-list-tile>
                  <v-list-tile-action @click.prevent="toggleSelect(selectAll)">
                    <v-checkbox v-model="selectAll" color="primary"></v-checkbox>
                  </v-list-tile-action>

                  <v-list-tile-content
                    @click.prevent="
                      selectAll = !selectAll
                      toggleSelect(selectAll)
                    "
                  >
                    <v-list-tile-title>
                      {{ $t('Select All') }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-flex>
              <v-flex>
                <div class="form-control pa-1">
                  <input type="text" v-model="search" class="mb-0" :placeholder="$t('Search')" />
                </div>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>

            <template v-for="(compare, index) in filterComparelist">
              <v-list-tile :key="'compare_' + compare.id">
                <v-list-tile-action>
                  <v-checkbox v-model="compare.selected" color="primary"></v-checkbox>
                </v-list-tile-action>

                <v-list-tile-content @click.prevent="compare.selected = !compare.selected">
                  <v-list-tile-title>
                    {{ intentLabel(compare.intentname) }}
                  </v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action
                  class="text-xs-center"
                  @click.prevent="compare.selected = !compare.selected"
                >
                  <v-list-tile-action-text v-if="!compare.page2" style="margin: auto">
                    {{ $t('Insert2') }}
                  </v-list-tile-action-text>
                  <v-list-tile-action-text v-else style="margin: auto" class="info--text">
                    {{ $t('Replace') }}
                  </v-list-tile-action-text>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider
                v-if="index + 1 < filterComparelist.length"
                :key="index"
                class="mt-2"
              ></v-divider>
            </template>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout wrap>
            <v-flex
              xs12
              sm8
              class="px-2 py-2"
              :class="{
                'red--text':
                  (totalIntent > maxintent &&
                    selectedBot.pagetype != 'enterprise' &&
                    $store.getters.getPackage != 'premium') ||
                  (totalIntent > 300 && selectedBot.pagetype != 'enterprise')
              }"
            >
              {{ $t('Current items') }} {{ currentIntent }} <span shrink class="px-2">+</span>
              {{ $t('New items') }} {{ newIntent }} <span shrink class="px-2">=</span>
              {{ totalIntent }}
            </v-flex>
            <v-flex xs12 sm4>
              <div class="text-xs-left text-sm-right py-2 pr-3 pl-2">
                <template
                  v-if="
                    selectedBot.pagetype != 'enterprise' && $store.getters.getPackage != 'premium'
                  "
                  >{{ $t('Maximum') }} {{ maxintent }}</template
                >
                <template v-else-if="selectedBot.pagetype != 'enterprise'"
                  >{{ $t('Maximum') }} 300</template
                >
                <template v-else>{{ $t('Unlimit') }}</template>
              </div>
            </v-flex>
          </v-layout>

          <div class="text-xs-right">
            <v-btn outline color="grey" @click="showTransfer = false">{{ $t('cancel') }}</v-btn>
            <v-btn depressed color="primary" :disabled="isSelected == 0" @click="saveTransfer">
              {{ $t('Save') }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ModalDialog from '@/components/elements/ModalDialog'
import api from '@/api'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import intentApi from '@/api/intent.js'
import { handleResponse, handleApiError } from '@/api/util'
export default {
  props: {
    type: {},
    intents: {},
    intentCount: { default: 0 }
  },
  data: () => {
    return {
      showTransfer: false,
      test: false,
      currentPage: null,
      comparelist: [],
      loading: true,
      selectAll: false,
      search: '',
      maxintent: 10,
      localIntents: [],
      total: 0
    }
  },
  components: {
    ModalDialog,
    ScaleLoader
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist'
    }),
    optionBotlist: function () {
      return this.botlist
        .filter((bot) => bot.pageid != this.selectedBot.pageid, [])
        .map((bot) => ({ name: bot.pagename, value: bot.pageid }))
    },
    isSelected: function () {
      return this.comparelist.filter(function (el) {
        return el.selected
      }, []).length
    },
    filterComparelist() {
      if (!this.search || this.search == '') {
        return this.comparelist
      }

      return this.comparelist.filter((intent) => {
        return intent.intentname.toLowerCase().includes(this.search.toLowerCase())
      })
    },
    totalIntent() {
      return this.intentCount + this.newIntent
    },
    currentIntent() {
      return this.intentCount
    },
    newIntent() {
      const insertlist = this.comparelist.filter((intent) => {
        return intent.selected && intent.page2 == false
      })
      return insertlist.length
    }
  },
  async mounted() {
    this.maxintent = this.type == 'conversation' ? 10 : 2
  },
  methods: {
    async getIntent() {
      const data = {
        pageid: this.selectedBot.pageid,
        sort_by: 'intentname',
        sort_type_available: 'asc'
      }
      try {
        const response = await intentApi.getIntent({ params: data })
        await handleResponse(response)
        if (response.data) {
          return {
            intents: response.data.data,
            total: response.data.total_count ? parseInt(response.data.total_count) : 0
          }
        }
      } catch (error) {
        handleApiError(error)
      }
    },
    openModal: function () {
      const vm = this
      vm.showTransfer = true
      if (vm.currentPage) {
        vm.loading = true
        vm.getCompareIntents(vm.currentPage).then(
          function () {
            vm.loading = false
          },
          function () {
            vm.loading = false
          }
        )
      } else {
        vm.loading = false
      }
    },
    selectBot(page) {
      const vm = this
      vm.currentPage = page
      vm.loading = true
      vm.getCompareIntents(vm.currentPage).then(
        function () {
          vm.loading = false
        },
        function () {
          vm.loading = false
        }
      )
    },
    getCompareIntents: function (page) {
      const vm = this
      return new Promise((resolve, reject) => {
        const data = {
          pageid1: page.value,
          pageid2: vm.selectedBot.pageid,
          type: vm.type == 'replycomment' ? 'replycomment' : 'conversation'
        }
        api.getCompareIntents(data, function (error, response) {
          if (error) {
            reject(error)
          }
          vm.comparelist = []
          if (response.data) {
            response.data = response.data.sort(function (a, b) {
              let nameA = a.intentname.toLowerCase(),
                nameB = b.intentname.toLowerCase()
              if (a.intentname[0] === '{' && a.intentname[a.intentname.length - 1] === '}') {
                return 1
              }
              if (b.intentname[0] === '{' && b.intentname[b.intentname.length - 1] === '}') {
                return -1
              }
              if (nameA < nameB) {
                return -1
              }
              if (nameA > nameB) {
                return 1
              }
            })
            vm.comparelist = response.data.map(function (compare) {
              return { ...compare, selected: true }
            })
          }
          resolve()
        })
      })
    },
    saveTransfer: function () {
      const vm = this
      vm.$swal
        .fire({
          title: vm.$t('Are you sure you want to transfer the conversation?'),
          text: vm.$t(
            'Once you confirmed, you cannot go back and the existing conversation will be replaced.'
          ),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            let intentsid = []

            if (vm.comparelist) {
              intentsid = vm.comparelist
                .filter((intent) => intent.selected, [])
                .map((intent) => intent.id)
            }

            if (
              vm.totalIntent > vm.maxintent &&
              vm.selectedBot.pagetype != 'enterprise' &&
              vm.$store.getters.getPackage != 'premium'
            ) {
              vm.$swal.fire({
                type: 'error',
                title: vm.$t(
                  'Transferring conversation cannot be applied since you have reached {size} set of Q&A.',
                  { size: vm.maxintent }
                ),
                footer: `<div class="text-xs-center"><a href="/${vm.$i18n.locale()}/upgrade">${vm.$t(
                  'If you wish to transfer, please click here to upgrade to premium package'
                )}</a></div>`
              })
              return false
            }

            if (
              vm.totalIntent > 300 &&
              vm.selectedBot.pagetype != 'enterprise' &&
              !vm.$store.state.UnlimitedConversation.includes(vm.selectedBot.pageid)
            ) {
              vm.$swal.fire({
                type: 'error',
                title: vm.$t(
                  'Transferring conversation cannot be applied since you have reached {size} set of Q&A.',
                  { size: 300 }
                )
              })
              return false
            }

            if (intentsid.length == 0) {
              return false
            }

            const data = {
              pageid1: vm.currentPage.value,
              pageid2: vm.selectedBot.pageid,
              intentsid: intentsid.join(',')
            }

            vm.$store.dispatch('loading')
            api.transferIntents(data, function (error, response) {
              if (error) {
                vm.$store.dispatch('loading')
                vm.$swal.fire({
                  title: vm.$t('Transfer conversation unsuccessful'),
                  type: 'error',
                  confirmButtonText: vm.$t('Confirm'),
                  cancelButtonText: vm.$t('cancel'),
                  reverseButtons: true
                })
                return false
              }
              vm.showTransfer = false
              vm.$store.dispatch('loading')
              vm.$swal
                .fire({
                  title: vm.$t('Transfer conversation successful'),
                  type: 'success',
                  confirmButtonText: vm.$t('Confirm'),
                  cancelButtonText: vm.$t('cancel'),
                  reverseButtons: true
                })
                .then(function (result) {
                  if (result.value) {
                    location.reload()
                  }
                })
            })
          }
        })
    },
    toggleSelect: function (value) {
      var vm = this
      if (vm.comparelist) {
        vm.comparelist.map(function (compare, index) {
          vm.comparelist[index].selected = value
        })
      }
    }
  },
  watch: {
    isSelected: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.selectAll = newVal == this.comparelist.length
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/TransferIntent.vue